import React, { useState } from 'react'
import Placeholder from '../misc/placeholder'
import { formatValueV2 } from '../../helpers/funcs'

const SectionTableVertical = props => {

    const [expanded, setExpanded] = useState([])

    const toggleItem = (id) => {
        expanded.indexOf(id) > -1 ?
            setExpanded(expanded.filter(p => p !== id))
            : setExpanded(expanded.concat(id))
    }

    const formatColumnValue = (col, row) => {
        if (col.maxLength) {
            return row[col.id || col.label].substr(0, col.maxLength) + (row[col.id || col.label].length > col.maxLength ? '...' : '')
        }
        if (col.format) {
            return formatValueV2(row[col.id || col.label])
        }
        return row[col.id || col.label]
    }

    const { data, cols, labelCol, Subtitle } = props
    return data ? (
        <section className="section d-sm-none">
            <h3 className="section-header">{props.Title || 'List'}{props.Total ? ` (${data ? data.length : 0})` : ''}
                {Subtitle && (
                    <React.Fragment>
                        <br />
                        <small className="subtitle">{Subtitle}</small>
                    </React.Fragment>
                )}
            </h3>
            <hr />
            {cols && cols.filter(col => col.totalize).length && data.length ? (
                <div className="project-details">
                    <dl className="row no-gutters mt-2">
                        {cols.filter(col => col.totalize).map((col, idx) => (
                            <React.Fragment key={`t-${idx}`}>
                                <div className="col-5 col-sm-2">
                                    <dt>{col.label}</dt>
                                </div>
                                <div className="col-7 col-sm-10">
                                    <dd>{formatValueV2(data.reduce((acum, obj) => {
                                        return acum + +obj[col.id || col.label]
                                    }, 0), '$0,0.00')}</dd>
                                </div>
                            </React.Fragment>
                        ))}
                    </dl>
                </div>
            ) : null}
            {data && data.length > 0 ? (
                <ul className="projectListVertical">
                    {data.map((p, idx) => (
                        <li key={idx} className={expanded.indexOf(idx) > -1 ? 'active' : ''} onClick={() => toggleItem(idx)}>
                            <i className={`fas fa-caret-${expanded.indexOf(idx) > -1 ? 'down' : 'right'}`} />
                            {' '}
                            {labelCol.split(',').map((lbl, l1) => (
                                l1 === 0 ? <strong key={l1}>{p[lbl]}</strong> : <span key={l1}> | {p[lbl]}</span>
                            ))}
                            <div className="project-details">
                                <dl className="row no-gutters mt-2">
                                    {cols ? cols.map((col, idx1) => (
                                        <React.Fragment key={idx1}>
                                            <div className="col-4 col-sm-2">
                                                <dt>{col.label}</dt>
                                            </div>
                                            <div className="col-8 col-sm-10">
                                                <dd>{formatColumnValue(col, p)}</dd>
                                            </div>
                                        </React.Fragment>
                                    )) : null}
                                </dl>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : <p>No data for this category.</p>}
        </section>
    ) : <Placeholder />
}


export default SectionTableVertical